import createClient from "openapi-fetch"
import type { paths } from "./api-types"

/**
 * Portal API Client — typed via openapi-typescript.
 *
 * Nutzung:
 *   const { data, error } = await api.GET("/api/v1/dashboard")
 *   data ist vollstaendig typed als DashboardResponse.
 *
 * Cookies werden per credentials:"include" mitgeschickt — das ist wichtig,
 * weil Auth über die bestehende admin_session-Cookie läuft.
 */
export const api = createClient<paths>({
  baseUrl: "",  // Same-Origin (in Prod) oder per Vite-Proxy (in Dev)
  credentials: "include",
})

/**
 * Regeneriert die api-types.ts aus dem laufenden Backend:
 *   npm run api:types
 * (siehe package.json scripts)
 */
